// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__c4ZzK","selected":"Chip_selected__2CIZS"};